<template>
  <div style="margin-bottom: 10%">
    <breadcrumb v-bind:path1="path1" v-bind:path2="orderDetail.SONum"></breadcrumb>
    <div class="container">
      <!-- login  -->
      <div v-show="loggedIn===true" class="page-width">
        <div class="header_container">
          <h3>{{ $t('orderDetail') }}</h3>
          <div>
            <button
              v-if="orderDetail.PaymentStatus==='Not Paid' && !orderDetail.IsBypassPayment"
              :disabled="orderDetail.SaleStatus==='Open'"
              :class="orderDetail.SaleStatus==='Open' ? 'disable-btn ' : 'btn'"
              @click="saveOrderInfo(orderDetail, $event)"
            >
              {{ $t('pay') }}
            </button>
            <button class="btn" @click="print()"> {{ $t('printBol') }}</button>
            <a
              :href="orderDetail.PODFileUrl"
              download
              v-show="orderDetail.PODFileUrl!=='' && orderDetail.PODFileUrl!==null"
            >
              <button class="btn"> {{ $t('PODFile') }}</button>
            </a>
          </div>
        </div>
        <div class="main-content">
          <div class="grid">
            <!-- medium up two thirds -->
            <div class="grid__item medium-up--two-thirds">
              <!-- sales order details -->
              <h2>{{ $t('orderNo') }} {{orderDetail.SONum}}</h2>
              <p v-if="orderDetail.TrackingNumber">{{ $t('trackingNumber') }}:
                <!-- <a class="tracking-link" :href="'https://www.fedex.com/apps/fedextrack/?tracknumbers=' + orderDetail.TrackingNumber" target="_blank">
                  {{orderDetail.TrackingNumber}}
                </a> -->
              </p>
              <p>{{ $t('placedOn') }}: {{getOrderTime(orderDetail.OrderDate)}}</p>
              <table class="responsive-table history">
                <thead>
                  <tr>
                    <th>{{ $t('referenceNum') }}</th>
                    <th>{{ $t('PRONo') }}</th>
                    <th>{{ $t('numPkgs') }}</th>
                    <th>{{ $t('OrigPallet') }}</th>
                    <th>{{ $t('InboundPallet') }}</th>
                    <th>{{ $t('weight') }}</th>
                    <th>{{ $t('commodityDesc') }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in orderDetail.lines" data-index="index" :key="index" class="responsive-table__row">
                  <td data-label="referenceNum">
                    {{item.RefNo}}
                  </td>
                  <td data-label="numPkgs">
                    {{item.PoNo}}
                  </td>
                  <td data-label="numPkgs">
                    {{item.TotalPKGS}}
                  </td>
                  <td data-label="ORIG Pallet">
                    {{item.OriginalQuantity}}
                  </td>
                  <td data-label="Inbound Pallet" v-if="orderDetail.ShippingStatus === 'Open'">
                    0
                  </td>
                  <td data-label="Inbound Pallet" v-if="orderDetail.ShippingStatus !== 'Open'">
                    {{item.TotalQuantity}}
                  </td>
                  <td data-label="weight">
                    {{item.TotalWeights}}
                  </td>
                  <td data-label="packageInfo">
                    {{item.AdditionalInfo}}
                  </td>
                </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <td colspan='2' class='small--hide fontStyle'>{{ $t('bolNumber') }}</td>
                    <td colspan='5'>{{orderDetail.CustomerBOL}}</td>
                  </tr>
                  <tr>
                    <td colspan='2' class='small--hide fontStyle'>{{ $t('container#') }}</td>
                    <td colspan='5'>{{orderDetail.ContainerNo}}</td>
                  </tr>
                  <tr>
                    <td colspan='2' class='small--hide fontStyle'>{{ $t('outboundQuantity') }}</td>
                    <td colspan='5'>{{orderDetail.TotalOutboundQuantity}}</td>
                  </tr>
                  <tr>
                    <td colspan='2' class='small--hide fontStyle'>{{ $t('total') }}</td>
                    <td colspan='5'>${{getAmount(orderDetail.TotalPrice)}}</td>
                  </tr>
                </tfoot>
              </table>
              <!-- end sales order details -->

              <!-- order track log -->
              <h2>{{ $t('orderTrackLog') }}</h2>
              <table class="responsive-table history" v-if="orderTrackLog.length > 0 ">
                <thead>
                  <tr>
                    <th>{{ $t('note') }}</th>
                    <th>{{ $t('date') }}</th>
                    <th>{{ $t('operatorName') }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in orderTrackLog" data-index="index" :key="index" class="responsive-table__row">
                    <td data-label="note">{{item.Note}}</td>
                    <td data-label="date">{{getOrderTime(item.CreateTime)}}</td>
                    <td data-label="operatorName">{{item.OperatorName}}</td>
                  </tr>
                </tbody>
              </table>
              <!-- end track log -->

              <!-- bol image -->
              <div v-for="(image, index) in orderDetail.OrderImages" :key='index'>
                <img :style="'width: 100%;'" :src="image.ImageURL" alt="">
              </div>
              <!-- end bol image -->

            </div>
            <!-- end medium up two thirds -->

            <!-- medium up one thirds -->
            <div class="grid__item medium-up--one-third">
              <h3>{{ $t('shippingAddress') }}</h3>
              <p>
                <strong>{{ $t('paymentStatus') }}:</strong>
                {{orderDetail.PaymentStatus}}
                <br>
                <strong>{{ $t('fulfillmentStatus') }}:</strong>
                {{orderDetail.ShippingStatus}}
              </p>
              <p>
                <strong>{{ $t('shipFrom') }}</strong>
                <br>
                {{orderDetail.ShipFrom}}
                <br>
                <strong>{{ $t('shipTo') }}</strong>
                <br>
                {{orderDetail.ShipTo}}
              </p>
            </div>
            <!-- end medium up one thirds -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapMutations, mapState} from 'vuex';
import breadcrumb from '../components/breadcrumb';
import moment from 'moment';

export default {
  name: "warehouseOrderHistoryDetail",
  loaded: false,
  components: {
      breadcrumb,
  },
  data() {
    return {
      path1: {
        name: this.$t('order'),
        path: '/warehouseOrderHistory',
      },
      path2: '',
      orderDetail: {
        BolImageUrl: '',
        OrderDate: '',
        SONum: '',
        IsBypassPayment: '',
        ShipFrom: '',
        ShipTo: '',
        CustomerBOL: '',
        SCAC: '',
        ProNo: '',
        lines: [],
        PaymentStatus: '',
        ShippingStatus: '',
        SaleStatus: '',
        TotalPrice: '',
      },
      orderTrackLog: [],
    }
  },
  methods: {
    ...mapActions('warehouseOrder', ['fetchOrderDetails', 'fetchOrderTrackLogs', 'printBol']),
    ...mapMutations('warehouseOrder', ['getOrderDetailHistory']),
    fetchOrderDetail(orderId) {
      this.fetchOrderDetails(orderId)
      .then(res => {
        this.orderDetail = res.data;
      })
      .catch(err => {
        console.log('fetchOrderDetail error: ', err);
      })
    },
    fetchOrderTrackLog(orderId) {
      this.fetchOrderTrackLogs(orderId)
        .then(res => {
          this.orderTrackLog = res.data;
        })
        .catch(err => {
          console.log('fetchOrderDetail error: ', err);
        })
    },
    getOrderTime(OrderDate) {
      return moment(OrderDate).format('MMMM Do YYYY, h:mm:ss a');
    },
    getEstTime(DispatchDate) {
      return moment(DispatchDate).format('MMMM Do YYYY');
    },
    getAmount(price) {
      return parseFloat(price).toFixed(2);
    },
    saveOrderInfo(orderDetail, event) {
      event.preventDefault();
      this.getOrderDetailHistory(orderDetail); // save in store
      this.$router.push(`/payment/${orderDetail.SONum}`); // go to payment page
    },
    print() {
      this.printBol(this.orderId)
      .then(res => {
        let blob = new Blob([res.data], {type: 'application/pdf'}),
        url = window.URL.createObjectURL(blob);
        window.open(url);
      })
      .catch(err => {
        console.log('fetchOrderDetail error: ', err);
      })
    },
  },
  computed: mapState({
    loggedIn: state => state.auth.loggedIn,
    orderTimeFrame: state => state.order.orderTimeFrame
  }),
  watch: {
    '$route.params': {
      immediate: true,
      handler(newVal) {
        this.orderId = newVal.order_id;
        this.fetchOrderDetail(this.orderId);
        this.fetchOrderTrackLog(this.orderId);
      }
    },
    orderDetails: function (newVal, oldVal) {},
  },
  mounted: function () {
    this.orderId = this.$route.params.order_id;
    this.fetchOrderDetail(this.orderId);
    this.fetchOrderTrackLog(this.orderId);
  },
}
</script>

<style scoped lang="less">
// @import "../assets/css/public.less";
// @import "../assets/css/account.less";
@import "../assets/css/order.less";
@import "../assets/css/warehouseOrderHistory.less";
</style>



// WEBPACK FOOTER //
// src/view/warehouseOrderHistoryDetail.vue